import React from "react";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { LocationOn as LocationOnIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import * as Styled from "./styles";

import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";

type TrackedDeliveriesProps = {
  data: {
    porcentage: number;
    deliveriesWithDriver: number;
    driverlessDeliveries: number;
  };
};

const TrackedDeliveries = ({
  data: { porcentage, deliveriesWithDriver, driverlessDeliveries },
}: TrackedDeliveriesProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.ContainerTitle>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {t("trackedDeliveries")}
        </Typography>
        <Tooltip
          placement="top"
          title={
            <h1 style={{ fontSize: 15 }}>
              Desde o dia 19/03/2025 a (% ) de entregas rastreadas estão sendo
              calculadas levando em consideração pedidos que foram finalizados
              pelo aplicativo do entregador próximo ao endereço do cliente.
              Apenas pedidos feitos pelo canais de delivery são considerados:
              aplicativo do consumidor e Whatsapp.
            </h1>
          }
        >
          <IconButton>
            <ReportGmailerrorredIcon color="error" fontSize="small" />
          </IconButton>
        </Tooltip>
      </Styled.ContainerTitle>
      <Grid container columns={12}>
        <Grid item display="flex" alignItems="center">
          <Styled.ContentPercentage>
            <Typography variant="h4" component="div" marginLeft={1}>
              {(Math.round(porcentage) / 100).toLocaleString("pt-BR", {
                style: "percent",
              })}
            </Typography>
          </Styled.ContentPercentage>
        </Grid>
        <Grid item display="flex" alignItems="center">
          <Styled.ContentDeliveries>
            <LocationOnIcon style={{ marginRight: 5 }} />
            <div>
              <Typography
                color="text.secondary"
                display="flex"
                flexDirection="row"
              >
                {t("trackedOrders")}
                <Typography
                  marginLeft={0.5}
                  style={{ fontWeight: 700 }}
                  color="#9847F5"
                >
                  {deliveriesWithDriver}
                </Typography>
              </Typography>
              <Typography
                color="text.secondary"
                display="flex"
                flexDirection="row"
              >
                {t("untrackedOrders")}
                <Typography
                  marginLeft={0.5}
                  style={{ fontWeight: 700 }}
                  color="text.secondary"
                >
                  {driverlessDeliveries}
                </Typography>
              </Typography>
            </div>
          </Styled.ContentDeliveries>

          {/* <Typography color="text.secondary" variant="subtitle2" fontSize={18}>
            Indicador em atualização, em breve estará visível corretamente.
          </Typography> */}
        </Grid>
      </Grid>
    </>
  );
};

export default TrackedDeliveries;
